<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['consultation_patients']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :busy="IsBusy"
                  show-empty
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>Loading data...</strong></div></template>
                <template #empty><div class="text-center text-muted my-3"><strong>No data found</strong></div></template>
                <template #cell(index)="data">
                  {{ ((currentPage - 1) * perPage) + data.index + 1 }}
                </template>
                <template #cell(name)="data">
                  {{ data.item.patient.name }}
                </template>
                <template #cell(date_of_birth)="data">
                  {{ data.item.patient.date_of_birth }}
                </template>
                <template #cell(gender)="data">
                  {{ data.item.patient.gender }}
                </template>
                <template #cell(telephone)="data">
                  0{{ data.item.patient.telephone }}
                </template>
                <template #cell(diagnosis)="data">
                  <div v-html="data.item.diagnosis"></div>
                </template>
                <template #cell(actions)="data">
                    <router-link :to="{ path: '/inpatienttreatment', query: { id:data.item.id, }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-square-edit-outline"></i> Treatment</router-link>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                      
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View In Patients</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { inPatientMethods, inPatientComputed } from "@/state/helpers";

export default {
  page: {
    title: "In Patients",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "In Patients",
      items: [ {text: "Dashboard",to: "/",}, {text: "In Patients",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      isBusy: true,
      hasLoaded: false,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'gender', label: 'Gender', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'date_of_birth', label: 'Date of Birth', visible: true },
          { key: 'diagnosis', label: 'Provisional Diagnosis', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
    };
  },
  computed: {
    ...inPatientComputed,
    List() { return this.TotalRows; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.inpatients.map((d) => ({...d }))},
    IsBusy() { return this.isBusy; },
  },
  mounted() {
    this.loadInPatients();
  },
  watch: {
    currentPage() {
      this.loadInPatients();
    },
    perPage() {
      this.currentPage = 1;
      this.loadInPatients();
    },
    filter() {
      this.currentPage = 1;
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.loadInPatients();
      }, 300);
    },
  },
  methods: {
    ...inPatientMethods,
    async loadInPatients() {
      this.isBusy = true;
      const response = await this.fetchInPatients({
        page: this.currentPage,
        per_page: this.perPage,
        search: this.filter || "",
      });
      this.TotalRows = response.data.pagination?.total || 0;
      this.hasLoaded = true;
      this.isBusy = false;
    },
  }
};
</script>
